(function(){
  if(window.__wlMaxQtyInit) return; window.__wlMaxQtyInit = true;
  var MAXRE = /maximum quantity|already in your cart|can only add/i;
  var SEL = '.hdt-form-message--error, .hdt-form__message--error';
  var BTN = '.hdt-product-form__submit, .hdt-sticky-atc__submit';
  var MAX_LBL = 'Max in cart', MAX_ARIA = 'Maximum quantity already in your cart';
  var warmCache = null;

  function markMaxed(btn, form){
    if(!btn) return;
    if(!btn.getAttribute('data-wl-max-owned')){
      btn.setAttribute('data-wl-max-owned','1');
      btn.setAttribute('data-wl-max-prev-disabled', btn.disabled ? '1' : '0');
    }
    btn.classList.add('wl-atc-maxed');
    btn.disabled = true;
    if(form && form.classList) form.classList.add('wl-atc-maxed-form');
    var lbl = btn.querySelector('span');
    if(lbl && !btn.getAttribute('data-wl-lbl')){
      btn.setAttribute('data-wl-lbl', lbl.textContent);
      lbl.textContent = MAX_LBL;
    }
    if(!btn.hasAttribute('data-wl-max-aria')){ btn.setAttribute('data-wl-max-aria', btn.getAttribute('aria-label') || ''); btn.setAttribute('aria-label', MAX_ARIA); btn.setAttribute('title', MAX_ARIA); }
  }
  function clearMaxed(form){
    if(!form) return;
    form.classList && form.classList.remove('wl-atc-maxed-form');
    var btn = form.querySelector('.hdt-product-form__submit.wl-atc-maxed, .hdt-sticky-atc__submit.wl-atc-maxed');
    if(!btn) return;
    btn.classList.remove('wl-atc-maxed');
    var lbl = btn.querySelector('span'), prev = btn.getAttribute('data-wl-lbl');
    var current = lbl ? (lbl.textContent || '').trim() : '';
    var nativeUnavailable = /sold out|unavailable/i.test(current);
    if(lbl && prev && (current === MAX_LBL || current === 'Max already in cart')) lbl.textContent = prev;
    if(btn.hasAttribute('data-wl-max-aria')){ var a = btn.getAttribute('data-wl-max-aria'); if(a) btn.setAttribute('aria-label', a); else btn.removeAttribute('aria-label'); btn.removeAttribute('title'); btn.removeAttribute('data-wl-max-aria'); }
    btn.removeAttribute('data-wl-lbl');
    if(btn.getAttribute('data-wl-max-owned') === '1'){
      if(btn.getAttribute('data-wl-max-prev-disabled') === '0' && !nativeUnavailable) btn.disabled = false;
      btn.removeAttribute('data-wl-max-owned');
      btn.removeAttribute('data-wl-max-prev-disabled');
    }
  }

  /* Restore the proven stock-cap preflight: once the selected variant is already
     at its server-rendered max, the ATC control is disabled before another add
     can reach the cart owner/network path. This uses the same cart line max that
     drives the drawer's grey + button; it does not create a second cart owner. */
  function rowFor(vid){
    if(!vid) return null;
    return document.querySelector('#CartDrawer hdt-line-item[data-wl-vid="'+String(vid)+'"]:not([data-wl-gift="1"])');
  }
  function cartQty(vid){
    var C = window.wlCartCore, st = C && C.current ? C.current() : null, q = 0, i;
    if(st && st.lines){
      for(i=0;i<st.lines.length;i++){
        var l = st.lines[i];
        if(l && !l.gift && !l.hidden && Number(l.vid) === Number(vid)) q += Number(l.qty) || 0;
      }
      return q;
    }
    var rows = document.querySelectorAll('#CartDrawer hdt-line-item[data-wl-vid="'+String(vid)+'"]:not([data-wl-gift="1"])');
    for(i=0;i<rows.length;i++){
      var inp = rows[i].querySelector('input[name="updates[]"]');
      q += parseInt(inp && inp.value,10) || 0;
    }
    return q;
  }
  function warmData(){
    if(warmCache) return warmCache;
    var el = document.getElementById('wl-pdp-cart-warm');
    if(!el) return null;
    try{ warmCache = JSON.parse(el.textContent || '{}'); }catch(_){ warmCache = null; }
    return warmCache;
  }
  function stockCap(vid){
    var row = rowFor(vid), n = parseInt(row && row.getAttribute('data-wl-max'),10);
    if(!isNaN(n) && n > 0) return n;
    var w = warmData(), d = w && w.details && w.details[String(vid)];
    n = parseInt(d && d.max,10);
    return !isNaN(n) && n > 0 ? n : 0;
  }
  function atStockCap(vid){
    var max = stockCap(vid);
    return max > 0 && cartQty(vid) >= max;
  }
  function formVid(form){
    if(!form || !form.querySelector) return 0;
    var input = form.querySelector('input[name="id"],select[name="id"]');
    return parseInt(input && input.value,10) || 0;
  }
  function isAddForm(form){
    if(!form || form.tagName !== 'FORM') return false;
    var action = form.action || form.getAttribute('action') || '';
    return /\/cart\/add(?:\.js)?(?:\?|$)/.test(action) || /\/cart\/add(?:\?|$)/.test(action);
  }
  function syncFormCap(form){
    if(!isAddForm(form)) return;
    var vid = formVid(form), btn = form.querySelector(BTN);
    if(!vid || !btn) return;
    if(atStockCap(vid)) markMaxed(btn, form);
    else clearMaxed(form);
  }
  function syncAllCaps(root){
    root = root || document;
    if(root.matches && root.matches('form')) syncFormCap(root);
    if(!root.querySelectorAll) return;
    var forms = root.querySelectorAll('form');
    for(var i=0;i<forms.length;i++) syncFormCap(forms[i]);
  }
  function queueCapSync(root){
    setTimeout(function(){ syncAllCaps(root || document); },0);
  }

  function sync(wrap){
    var msg = wrap.querySelector('.hdt-error-message');
    if(!msg) return;
    if(wrap.hasAttribute('hidden')) return;
    if(!MAXRE.test((msg.textContent || '').trim())) return;
    var form = (wrap.closest && (wrap.closest('form') || wrap.closest('.hdt-product-form'))) || wrap.parentElement;
    if(!form) return;
    var btn = form.querySelector(BTN);
    if(!btn) return;
    markMaxed(btn, form);
  }

  var watched = (typeof WeakSet !== 'undefined') ? new WeakSet() : { has:function(){return false;}, add:function(){} };
  function watch(wrap){
    if(watched.has(wrap)) return; watched.add(wrap);
    try{ new MutationObserver(function(){ sync(wrap); }).observe(wrap, { attributes:true, attributeFilter:['hidden'], childList:true, subtree:true, characterData:true }); }catch(_){}
    sync(wrap);
  }
  function scan(root){
    if(!root || !root.querySelectorAll) return;
    if(root.matches && root.matches(SEL)) watch(root);
    var list = root.querySelectorAll(SEL);
    for(var i=0;i<list.length;i++) watch(list[i]);
    queueCapSync(root);
  }

  /* Existing product/featured-product forms are present now. */
  scan(document);

  /* Quick View / Quick Add are lazy-created by hdt-tmp-quick. Observe only the
     temporary injector's direct parent until the modal shells appear; then disconnect
     that observer and watch only the two modal inner containers that LazyModal replaces.
     This preserves AJAX-injected max-quantity feedback without a permanent whole-page
     MutationObserver. */
  var modalRoots = (typeof WeakSet !== 'undefined') ? new WeakSet() : { has:function(){return false;}, add:function(){} };
  function observeModalInner(inner){
    if(!inner || modalRoots.has(inner)) return;
    modalRoots.add(inner);
    scan(inner);
    try{
      new MutationObserver(function(muts){
        for(var i=0;i<muts.length;i++){
          var added = muts[i].addedNodes || [];
          for(var j=0;j<added.length;j++){
            var n = added[j];
            if(n && n.nodeType === 1) scan(n);
          }
        }
      }).observe(inner, { childList:true, subtree:true });
    }catch(_){}
  }
  function wireModalRoots(){
    var found = 0;
    ['#hdt-quick-view-modal', '#hdt-quick-add-modal'].forEach(function(sel){
      var modal = document.querySelector(sel);
      if(!modal) return;
      found++;
      observeModalInner(modal.querySelector('.hdt-dialog-modal__inner') || modal);
    });
    return found;
  }
  if(!wireModalRoots()){
    var tmp = document.querySelector('hdt-tmp-quick');
    var parent = tmp && tmp.parentNode;
    if(parent){
      try{
        var shellObserver = new MutationObserver(function(){
          if(wireModalRoots()) shellObserver.disconnect();
        });
        shellObserver.observe(parent, { childList:true });
      }catch(_){}
    }
  }

  /* Cart state is authoritative. Re-evaluate after every mutation/render; the
     queued pass runs after the drawer owner has finished restoring button state. */
  document.addEventListener('wl:cart:state', function(){ queueCapSync(document); });
  document.addEventListener('wl:cart:render', function(){ queueCapSync(document); });

  document.addEventListener('change', function(e){
    var f = e.target && e.target.closest ? e.target.closest('form') : null;
    if(f) setTimeout(function(){ clearMaxed(f); syncFormCap(f); },0);
    if(f) setTimeout(function(){ syncAllCaps(document); },250);
  });
  document.addEventListener('click', function(e){
    var t = e.target && e.target.closest ? e.target.closest('.hdt-product-form label, hdt-variant-option, .hdt-variant-picker label') : null;
    if(t){ var f = t.closest('form'); if(f) setTimeout(function(){ clearMaxed(f); syncFormCap(f); },0); setTimeout(function(){ syncAllCaps(document); },250); }
  });
})();
